import apiRequest from '../config/api'

export interface MainMenuItem {
    id: number;
    name: string;
    link_type: 'internal' | 'external';
    link?: string;
    order: number;
    is_active: boolean;
}

export interface MainMenu {
    id: number;
    name: string;
    type: 'normal' | 'dropdown';
    link_type?: 'internal' | 'external';
    link?: string;
    order: number;
    is_active: boolean;
    items: MainMenuItem[];
}

// ----- Get All Menus -----
export const getMenus = async (): Promise<MainMenu[]> => {
    await apiRequest.getCsrfCookie()
    const res = await apiRequest.get('/api/admin/main-menus')
    return res.data.data
}

export const getMainMenu = async (id: number): Promise<MainMenu> => {
    await apiRequest.getCsrfCookie()
    const res = await apiRequest.get(`/api/admin/main-menus/${id}`);
    return res.data.data;
};

// ----- Create Menu -----
export interface CreateMenuRequest {
    name: string
    type: 'normal' | 'dropdown'
    link_type?: 'internal' | 'external'
    link?: string
    order: number
    is_active: boolean
}

export const createMenu = async (
    payload: CreateMenuRequest
): Promise<MainMenu> => {
    await apiRequest.getCsrfCookie()
    const res = await apiRequest.post('/api/admin/main-menus', payload)
    return res.data
}

// ----- Update Menu -----
export interface UpdateMenuRequest {
    name?: string
    type?: 'normal' | 'dropdown'
    link_type?: 'internal' | 'external'
    link?: string
    order?: number
    is_active?: boolean
}

export const updateMenu = async (
    id: number,
    payload: UpdateMenuRequest
): Promise<MainMenu> => {
    await apiRequest.getCsrfCookie()
    const res = await apiRequest.put(`/api/admin/main-menus/${id}`, payload)
    return res.data
}

export const updateMenuStatus = async (id: number, is_active: boolean) => {
    await apiRequest.getCsrfCookie()
    const res = await apiRequest.put(`/api/admin/main-menus/${id}`, { is_active })
    return res.data.data
}


// ----- Delete Menu -----
export const deleteMenu = async (id: number): Promise<{ message: string }> => {
    await apiRequest.getCsrfCookie()
    const res = await apiRequest.delete(`/api/admin/main-menus/${id}`)
    return res.data
}

// Main Menu 
export interface ApiMenuItem {
    id: number;
    main_menu_id: number;
    name: string;
    link_type: "internal" | "external";
    link: string;
    order: number;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export interface ApiMenu {
    id: number;
    name: string;
    type: "normal" | "dropdown";
    link_type?: "internal" | "external";
    link?: string;
    order: number;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    items: ApiMenuItem[];
}

export const getHeaderMenus = async (): Promise<ApiMenu[]> => {
    await apiRequest.getCsrfCookie()
    const res = await apiRequest.get('/api/main-menus') // update with your endpoint
    return res.data.data
}

// Sub Menu

// For API response
export interface ApiMainMenuItem extends MainMenuItem {
    id: number;
    main_menu_id: number;
    created_at: string;
    updated_at: string;
}

// ------------------- Get Items by MainMenu ID -------------------
export const getMainMenuItems = async (main_menu_id: number): Promise<ApiMainMenuItem[]> => {
    await apiRequest.getCsrfCookie();
    const res = await apiRequest.get(`/api/admin/main-menu-items?main_menu_id=${main_menu_id}`);
    return res.data.data;
};

// ------------------- Create Item -------------------
export interface CreateMainMenuItemRequest {
    main_menu_id: number;
    name: string;
    link_type: 'internal' | 'external';
    link?: string;
    order: number;
    is_active: boolean;
}

export const createMainMenuItem = async (
    payload: CreateMainMenuItemRequest
): Promise<ApiMainMenuItem> => {
    await apiRequest.getCsrfCookie();
    const res = await apiRequest.post('/api/admin/main-menu-items', payload);
    return res.data.data;
};

// ------------------- Update Item -------------------
export interface UpdateMainMenuItemRequest {
    name?: string;
    link_type?: 'internal' | 'external';
    link?: string;
    order?: number;
    is_active?: boolean;
}

export const updateMainMenuItem = async (
    id: number,
    payload: UpdateMainMenuItemRequest
): Promise<ApiMainMenuItem> => {
    await apiRequest.getCsrfCookie();
    const res = await apiRequest.put(`/api/admin/main-menu-items/${id}`, payload);
    return res.data.data;
};

// ------------------- Delete Item -------------------
export const deleteMainMenuItem = async (id: number): Promise<{ message: string }> => {
    await apiRequest.getCsrfCookie();
    const res = await apiRequest.delete(`/api/admin/main-menu-items/${id}`);
    return res.data;
};